<button class="buttonFuentes-ref position-relative" (click)="onClickGotToSource(menuData.route)">

  <div 
    class="d-flex justify-content-start align-items-end h-70 text-break" 
    [ngClass]="{'buttonTextResponsive16':(menuData.title.length >= 50 && menuData.title.length <= 55),'buttonTextResponsive14': menuData.title.length >= 56,'buttoTextResponsiveRem':(menuData.title.length >= 40 && menuData.title.length <= 49)}"
  >
    {{ menuData.title }}
  </div>
</button>